import { Flex, SectionMessage, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useDepositInvoiceForm } from '../../contexts/depositInvoiceDetailsFormContext'
import { DepositInvoiceDetailsMultiVatTable } from './elements/DepositInvoiceDetailsMultiVatTable'
import { DepositInvoiceDetailsQuoteAmount } from './elements/DepositInvoiceDetailsQuoteAmount'
import { DepositInvoiceDetailsSplitAmountInput } from './elements/DepositInvoiceDetailsSplitAmountInput'

export const DepositInvoiceDetailsModalBody = (): ReactElement => {
  const { t } = useTranslation()
  const { remainingBalance } = useDepositInvoiceForm()

  const shouldDisplayFullQuoteAmountMessage = remainingBalance === 0

  return (
    <Flex flexDirection="column" gap={Spacing.S16}>
      <DepositInvoiceDetailsQuoteAmount />
      <DepositInvoiceDetailsSplitAmountInput />
      <DepositInvoiceDetailsMultiVatTable />

      {shouldDisplayFullQuoteAmountMessage && (
        <SectionMessage showIcon={true}>
          {t('external_invoices.deposit_invoice_details_modal.full_quote_amount_message')}
        </SectionMessage>
      )}
    </Flex>
  )
}
